import { Component, OnInit } from '@angular/core';
import { StoreService } from './../../../../services/store.service';
import { ApiService } from './../../../../services/api.service';
import { Profil } from './../../../../models/Profil';
import { CommandeService } from './../../../../services/commande.service';
import { SelectItem, Message, ConfirmationService, UIChart } from 'primeng/primeng';
import { CommandeBordereau } from 'src/app/models/CommandeBordereau';
import { CommandeDetail } from 'src/app/models/CommandeDetail';
import { Commande } from 'src/app/models/Commande';
import { ThrowStmt } from '@angular/compiler';
import { ClientsService } from 'src/app/services/reporting/clients.service';
import { LocaliteService } from 'src/app/services/reporting/localites.service';
import { CriteriaData } from 'src/app/models/CriteriaData';
import { ReportingVenteService } from 'src/app/services/reporting/reporting.vente.service';
import { DatePipe } from '@angular/common';
import { GlobalVenteStat } from 'src/app/models/GlobalVenteStat';
import { GlobalVenteRegion } from 'src/app/models/GlobalVenteRegion';
import { ExcelService } from 'src/app/services/Excel.service';

@Component({
  selector: 'app-vente-global',
  templateUrl: './vente-global.component.html',
  styleUrls: ['./vente-global.component.css']
})
export class VenteGlobalComponent implements OnInit {

  titre = 'Ventes - Global';
  itemId: any;
  msgs: Message[] = [];

  fr = {
    firstDayOfWeek: 0,
    monthNames: [
      'Janvier', 'Février', 'Mars',
      'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre',
      'Octobre', 'Novembre', 'Décembre'
    ],
    monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
  };
  today: any = new Date();

  displaychargement:boolean;
  dataBar: any;
  dataBar3: any;
  dataPieTaux: any;
  dataPiePart: any;
  dataPie3: any;

  listMsisdn: SelectItem[] = [];
  listLogin: SelectItem[] = [];
  listRegroupment: SelectItem[] = [];
  listLocalite: SelectItem[] = [];
  listLocalite2: SelectItem[] = [];
  listLocalite3: SelectItem[] = [];
  listLocalite4: SelectItem[] = [];

  selectedCodedz: string;
  selectedSousZone: string;
  selectedSecteur: string;
  selectedLocalitedd: string;
  selectedPdg: string;
  selectedMsisdn: string;
  selectedRegroupement: string;
  datedebut: any = new Date();
  datefin: any = new Date();

  itemGlobal : GlobalVenteStat = new GlobalVenteStat();
  itemsGlobal: GlobalVenteStat[] = [];

  itemsRegionPart : GlobalVenteRegion[] = [];
  itemsRegionZone : GlobalVenteRegion[] = [];
  itemsRegionHorsZone : GlobalVenteRegion[] = [];

  displayRegroupementDZ:boolean=true;
  displayRegroupementSOUSZONE:boolean=false;
  displayRegroupementSECTEUR:boolean=false;
  displayRegroupementLOCALITE:boolean=false;

  constructor(private confirmationService: ConfirmationService,
    private commandeService: CommandeService,
    private datePipe: DatePipe,
    private localiteService: LocaliteService,
    private clientsService: ClientsService,
    private reportingVenteService: ReportingVenteService,
    private excelService: ExcelService,
    private store: StoreService) { }

  ngOnInit() {
    this.loadSelectList();
    this.initChartPieTaux();
    this.initChartPiePart();
  }

  async recherche(chartPieTaux: UIChart, chartPieTaux2: UIChart, chartPiePart: UIChart, chartPiePart2: UIChart) {
    if(this.selectedMsisdn === null || this.selectedMsisdn === undefined || this.selectedMsisdn === '') {
      //this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selection un msisdn PDG ' });
      //return;
    }
    if(this.datedebut === null || this.datedebut === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de debut !' });
      return;
    }
    if(this.datefin === null || this.datefin === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de fin !' });
      return;
    }

    let criteria: CriteriaData = new CriteriaData();
    criteria.codedz = this.selectedCodedz;
    criteria.souszone = this.selectedSousZone;
    criteria.secteur = this.selectedSecteur;
    criteria.localitedd = this.selectedLocalitedd;
    criteria.pdg = this.selectedPdg;
    criteria.msisdn = this.selectedMsisdn;
    criteria.regroupement = this.selectedRegroupement;
    criteria.datedebut = this.localeDateString(this.datedebut);
    criteria.datefin = this.localeDateString(this.datefin);
    criteria.horzone = "";
    console.log(JSON.stringify(criteria));

    this.displaychargement=true;
    try {
      this.itemGlobal = <any>await this.reportingVenteService.venteGlobal(criteria).toPromise();
    } catch (error) {
      
    }
    this.displaychargement=false;
    
    console.log('itemGlobal: ', this.itemGlobal);
    if(this.itemGlobal === null  || this.itemGlobal === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Une erreur est survenue sur le serveur !' });
      this.itemGlobal = new GlobalVenteStat();
      return;
    }
    this.itemGlobal.msisdn = this.selectedPdg;
    this.itemsGlobal = [];
    this.itemsGlobal.push(this.itemGlobal);

    // infos par region
    this.itemsRegionPart = [];
    this.itemsRegionZone = [];
    this.itemsRegionHorsZone = [];




    this.printChartPieTaux(chartPieTaux);
    this.printChartPieTaux(chartPieTaux2);
    this.printChartPiePart(chartPiePart);
    this.printChartPiePart(chartPiePart2);

  }


  printChartPieTaux(chart: UIChart) {
    this.dataPieTaux = {
      labels: ['ZONE','HORS_ZONE'],
      datasets: [
          {
              data: [+this.itemGlobal.total_zone, +this.itemGlobal.total_hors_zone],
              backgroundColor: [
                  "#00A056",
                  "#FFCE56"
              ],
              hoverBackgroundColor: [
                  "#00A056",
                  "#FFCE56"
              ]
          }]
      };
      setTimeout(() => {
        chart.ngOnDestroy();
        chart.initChart();
      }, 100);
  }

  initChartPieTaux() {
    this.dataPieTaux = {
      labels: ['ZONE','HORS_ZONE'],
      datasets: [
          {
              data: [0, 0],
              backgroundColor: [
                  "#00A056",
                  "#FFCE56"
              ],
              hoverBackgroundColor: [
                  "#00A056",
                  "#FFCE56"
              ]
          }]
      };
  }

  initChartPiePart() {
    this.dataPiePart = {
    labels: ['PART VENTE RECHARGE','PART VENTE NAFAMA'],
    datasets: [
        {
            data: [0, 0],
            backgroundColor: [
                "#00A056",
                "#FE9A2E"
            ],
            hoverBackgroundColor: [
                "#00A056",
                "#FE9A2E"
            ]
        }]
    };
  }

  printChartPiePart(chart: UIChart) {
    this.dataPiePart = {
    labels: ['PART VENTE RECHARGE','PART VENTE NAFAMA'],
    datasets: [
        {
            data: [+this.itemGlobal.carte_total, +this.itemGlobal.nafama_total ],
            backgroundColor: [
                "#00A056",
                "#FE9A2E"
            ],
            hoverBackgroundColor: [
                "#00A056",
                "#FE9A2E"
            ]
        }]
    };
    setTimeout(() => {
      chart.ngOnDestroy();
      chart.initChart();
    }, 100);
  }



    async loadSelectList() {

      this.displayRegroupementDZ=true;
    this.displayRegroupementSOUSZONE=false;
    this.displayRegroupementSECTEUR=false;
    this.displayRegroupementLOCALITE=false;

      this.listLogin = [];
      if(this.store.isUserPartenaire) {
        this.listLogin.push({ label: this.store.currentNomPDG, value: this.store.currentNomPDG });
        this.selectedPdg = this.store.currentNomPDG;
      } else {
        this.listLogin.push({ label: 'PDG...', value: null });
        try {
          let dataRetourPdg = <any>await this.clientsService.findAgents().toPromise();
          for (let el of dataRetourPdg) {
            this.listLogin.push({ label: el.login, value: el.login });
          }
        } catch (error) { }
      }
  
      this.listMsisdn = [];
      this.listMsisdn.push({ label: 'Msisdn...', value: null });
  
      this.listRegroupment = [];
      this.listRegroupment.push({ label: 'Niveau...', value: null });
      this.listRegroupment.push({ label: 'DZ', value: 'DZ' });
      this.listRegroupment.push({ label: 'Sous Zone', value: 'SOUSZONE' });
      this.listRegroupment.push({ label: 'Secteur', value: 'SECTEUR' });
      this.listRegroupment.push({ label: 'Code localité', value: 'LOCALITE' });
  
      try {
        this.listLocalite = [];
        this.listLocalite.push({ label: 'DZ...', value: null });
        let dataRetour = <any>await this.localiteService.findCodedz().toPromise();
        for (let el of dataRetour) {
          this.listLocalite.push({ label: el.codedz, value: el.codedz });
        }
      } catch (error) { }
  
      this.listLocalite2 = [];
      this.listLocalite2.push({ label: 'Sous zone...', value: null });
      this.listLocalite3 = [];
      this.listLocalite3.push({ label: 'Secteur...', value: null });
      this.listLocalite4 = [];
      this.listLocalite4.push({ label: 'Localite...', value: null });
  
    }

    async onChangeRegroupement(event) {
      console.log("event======="+event);
      if(event === 'SOUSZONE'){
        this.displayRegroupementDZ=false;
        this.displayRegroupementSOUSZONE=true;
        this.displayRegroupementSECTEUR=false;
        this.displayRegroupementLOCALITE=false;
      } else if(event === 'SECTEUR'){
        this.displayRegroupementDZ=false;
        this.displayRegroupementSOUSZONE=false;
        this.displayRegroupementSECTEUR=true;
        this.displayRegroupementLOCALITE=false;
      } else if(event === 'LOCALITE'){
        this.displayRegroupementDZ=false;
        this.displayRegroupementSOUSZONE=false;
        this.displayRegroupementSECTEUR=false;
        this.displayRegroupementLOCALITE=true;
      } else {
        this.displayRegroupementDZ=true;
        this.displayRegroupementSOUSZONE=false;
        this.displayRegroupementSECTEUR=false;
        this.displayRegroupementLOCALITE=false;
      } 
    }
  
    async onChangeLocalite(event) {
      this.listLocalite2 = [];
      this.listLocalite2.push({ label: 'Sous zone...', value: null });
      let dataRet = <any>await this.localiteService.findCodeSousZone(event).toPromise();
      for (let el of dataRet) {
        this.listLocalite2.push({ label: el.codeSousZone, value: el.codeSousZone });
      }
      this.listLocalite3 = [];
      this.listLocalite3.push({ label: 'Secteur...', value: null });
      this.listLocalite4 = [];
      this.listLocalite4.push({ label: 'Localite...', value: null });
    }
    async onChangeLocalite2(event) {
      this.listLocalite3 = [];
      this.listLocalite3.push({ label: 'Secteur...', value: null });
      let dataRet = <any>await this.localiteService.findCodeSecteur(event).toPromise();
      for (let el of dataRet) {
        this.listLocalite3.push({ label: el.codeSecteur, value: el.codeSecteur });
      }
      this.listLocalite4 = [];
      this.listLocalite4.push({ label: 'Localite...', value: null });
    }
  
    async onChangeLocalite3(event) {
      this.listLocalite4 = [];
      this.listLocalite4.push({ label: 'Localite...', value: null });
      let dataRet = <any>await this.localiteService.findCodeLocalitedd(event).toPromise();
      for (let el of dataRet) {
        this.listLocalite4.push({ label: el.codeLocalitedd + ' - ' + el.localitedd, value: el.localitedd });
      }
    }
  
    async onChangePDG(event) {
      this.listMsisdn = [];
      this.listMsisdn.push({ label: 'Msisdn...', value: null });
      let dataRet = <any>await this.clientsService.findByLogin(event).toPromise();
      for (let el of dataRet) {
        this.listMsisdn.push({ label: el.telephone, value: el.telephone });
      }
    }
  
  
    localeDateString(val: any): any {
      if (val === null || val === undefined) {
        return null;
      }
      if (typeof val === 'string') {
        return val;
      } else {
        return this.datePipe.transform(val, "dd/MM/yyyy");
      }
    }
    exporter(){
      
    }
}
